import React__default from 'react';
import { __rest, __assign } from '../../_virtual/_tslib.js';
import { Image } from '@deal/components';
import MessageBubble from '../MessageBubble/index.js';
import styles from './styles.css.js';

var MessageBubbleImage = function MessageBubbleImage(_a) {
  var url = _a.url,
      skipHref = _a.skipHref,
      onLoaded = _a.onLoaded,
      rest = __rest(_a, ["url", "skipHref", "onLoaded"]);

  var img = React__default.createElement(Image, {
    src: url,
    size: "100vw",
    sizeMd: "24rem",
    htmlAttributes: {
      onLoad: onLoaded
    },
    className: styles.image
  });
  return React__default.createElement(MessageBubble, __assign({}, rest), skipHref ? img : React__default.createElement("a", {
    href: url,
    target: "_blank",
    className: styles.link
  }, img));
};

export default MessageBubbleImage;
//# sourceMappingURL=index.js.map
